<template>
  <aside class="rb-emergency-box" :aria-label="$t('intake.emergencyAria')">
    <strong>{{ $t('intake.emergencyLead') }}</strong>
    <p>{{ $t('intake.emergencyIfIran') }}</p>
    <div v-if="resolvedContacts.length" class="rb-emergency-numbers">
      <a
          v-for="item in resolvedContacts"
          :key="item.tel + item.id"
          :href="'tel:' + item.tel"
      >
        <b><bdi>{{ toFaDigits(item.tel) }}</bdi></b>
        <span>{{ contactLabel(item) }}</span>
      </a>
    </div>
    <button
        v-else
        class="rb-ob-submit rb-ob-submit-secondary"
        type="button"
        @click="$emit('open-crisis')"
    >
      {{ $t('intake.crisisSeeHelp') }}
    </button>
  </aside>
</template>

<script>
import {toFaDigits} from '@/intake/intakeState'
import {loadCrisisResourceResult} from '@/intake/crisisResources'

export default {
  name: 'IntakeEmergencyBox',
  props: {
    contacts: {
      type: Array,
      default: null,
    },
  },
  emits: ['open-crisis'],
  data() {
    return {
      loadedContacts: [],
    }
  },
  computed: {
    resolvedContacts() {
      if (Array.isArray(this.contacts) && this.contacts.length) {
        return this.contacts
      }
      return this.loadedContacts
    },
  },
  async created() {
    if (Array.isArray(this.contacts) && this.contacts.length) {
      return
    }
    const result = await loadCrisisResourceResult('IR')
    this.loadedContacts = result.contacts || []
  },
  methods: {
    toFaDigits,
    contactLabel(item) {
      const key = 'intake.emergency.' + item.label
      if (this.$te && this.$te(key)) {
        return this.$t(key)
      }
      const crisisKey = 'intake.crisisContact.' + item.id
      if (this.$te && this.$te(crisisKey)) {
        return this.$t(crisisKey)
      }
      return item.displayName || item.id
    },
  },
}
</script>
